import { begatewayApi, byName } from '@/store/api/begateway/begateway.services.api';
import type { TypeAppDispatch } from '@/store/store';
import type { TypeGatewayService } from '@/types/begateway/types.begateway.service';

export const writeService = (dispatch: TypeAppDispatch, service: TypeGatewayService) => {
    dispatch(begatewayApi.util.updateQueryData('listGatewayServices', undefined, (draft) => {
        const index = draft.items.findIndex((entry) => entry.serviceId === service.serviceId);
        if (index >= 0) draft.items[index] = service; else draft.items.push(service);
        draft.items.sort(byName);
    }));
    dispatch(begatewayApi.util.updateQueryData('readGatewayService', service.serviceId, (draft) => ({ ...draft, ...service })));
};

export const dropService = (dispatch: TypeAppDispatch, serviceId: string) => {
    dispatch(begatewayApi.util.updateQueryData('listGatewayServices', undefined, (draft) => {
        const index = draft.items.findIndex((entry) => entry.serviceId === serviceId);
        if (index >= 0) draft.items.splice(index, 1);
    }));
    dispatch(begatewayApi.util.invalidateTags([{ type: 'GatewayService', id: serviceId }]));
};
